let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("4zbTA")).then(() => parcelRequire('1Cv5i'));